module.exports = __webpack_public_path__ + "static/5-ace4c7a218cd862d1e07bd7bff2ea079.jpg";